import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {SitePageChartDataModel} from '../models/SitePageChartDataModel';
import {HttpResponse} from '@angular/common/http';

@Injectable()
export class ChartsService {

    constructor(private httpService: HttpService) {}

    getPageReviewScoresChartData(pageId: number, scoreAccumulatorId: number, reviewDate: string): Observable<HttpResponse<Array<SitePageChartDataModel>>> {
        const url = environment.ENDPOINTS.GET_PAGE_REVIEW_SCORES_CHART_DATA
            .replace('{:pageId}', pageId.toString())
            .replace('{:scoreAccumulatorId}', scoreAccumulatorId.toString())
            .replace('{:reviewDate}', reviewDate);
        return this.httpService.getJson<Array<SitePageChartDataModel>>(url);
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/charts.service.ts